import React, { useEffect, useState } from 'react';
import './Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

import factoids from '../../info/factoids';
import FactoidSection from '../../components/FactoidSection';

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless d
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionFTTH.mp4",
    poster: "/videos/solutionFTTH.jpg",
    heading: "Fiber First. Everywhere It Counts",
    subheading: "Empowering fiber access for homes, buildings, and communities",
    buttonLink: "/solutions"
  }
];

function SolutionCentralOffice() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');



const productFamilies = [
  'Fiber Terminals & Closures',
  'Passive Optical Components',
  'Fiber Cable Assemblies',
];

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products

const [familyIndex, setFamilyIndex] = useState(0);
const [familySlidesPerView, setFamilySlidesPerView] = useState(3);

useEffect(() => {
  const update = () => {
    if (window.innerWidth <= 768) {
      setFamilySlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setFamilySlidesPerView(2);
    } else {
      setFamilySlidesPerView(3);
    }
  };

  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);

const familyMaxIndex = Math.max(topByFamily.length - familySlidesPerView, 0);

const nextFamily = () => {
  setFamilyIndex(prev => Math.min(prev + 1, familyMaxIndex));
};

const prevFamily = () => {
  setFamilyIndex(prev => Math.max(prev - 1, 0));
};

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={'/support'} className="cta-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-1">
        <div className="solutions-section-1-image-container">
          <img src="/images/solutions/ftth.jpg" alt="FTTX" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">FTTX and MDU networks are scaling at the edge</h2>
          <p className="solution-section-1-description">As demand for high-speed internet, streaming, AI, and smart living surges, taking fiber directly to the end user is more critical than ever. Service providers are deploying fiber deeper and faster, while balancing cost, density, and aesthetics. Advanced connectivity solutions from Go!Foton are fast to install, durable, and adaptable, making them essential to meet these challenges head-on.</p>
        </div>
      </div>

      <FactoidSection
        solution="fttx"
        title="Providers are racing to fiber-enable the last mile"
        description=""
      />


      <div className="solutions-section-checklist">
        <div className="solutions-section-checklist-left">
          <h2 className="solutions-section-checklist-heading">Built to deliver fiber access without compromise</h2>
          <div className="solutions-section-checklist-image-wrapper">
            <img src="/images/solutions/ftth2.png" alt="Central Office" />
          </div>
        </div>

        <div className="solutions-section-checklist-right">
          <p className="solutions-section-checklist-description">Our fiber optic solutions streamline FTTX and MDU deployments with compact designs, rapid installs, and field-friendly features, helping providers scale efficiently while minimizing costs per home passed. By optimizing infrastructure and deployment strategies, we reduce labor expenses, accelerate installation, and maximize coverage with fewer resources. Whether it’s one building or an entire community, we enable cost-effective expansion without compromising speed, reliability, or customer satisfaction.</p>
          <ul className="solutions-section-checklist-points">
            <li>Fast Delivery</li>
            <li>Compact</li>
            <li>Scalable</li>
            <li>Technician-Friendly</li>
            <li>Cost-Savings</li>
          </ul>
        </div>
      </div>


    <section className="solution-products-section">
      <h2>Bringing Fiber Home</h2>
      <p className="solution-products-section-description">Our innovative fiber optic solutions are engineered to support the evolving demands of your networks, ensuring fast deployments, scalability, and cost savings.</p>


<div className="products-grid">
  {topByFamily.map(({ family, topProduct }) => (
    <div key={family} className="product-card">
      {topProduct.image ? (
        <img
          src={topProduct.image}
          alt={family}
          style={{ width: '100%', height: 200, objectFit: 'cover' }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: 215,
            backgroundColor: '#ddd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontStyle: 'italic',
            color: '#666',
          }}
        >
          No Image Available
        </div>
      )}
      <h3>{family}</h3>
      <a
        href={`/${family.toLowerCase().replace(/\s+/g, '-')}`}
        className="learn-more"
      >
        Learn More
      </a>
    </div>
  ))}
</div>

    </section>

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default SolutionCentralOffice;
